// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--SOrRx","content":"content--MeQSc"};